import { ActivatedRouteSnapshot, ResolveFn, Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { permissionGuard } from './app-core/guards/permission.guard';
import { PermissionType } from './app-core/models/permission/permission-type-enum';


export const titleResolver: ResolveFn<string> = (route: ActivatedRouteSnapshot) => {
    const translate = inject(TranslateService);
    const path = route.pathFromRoot
        .flatMap(v => v.url.map(segment => segment.path))
        .filter(segment => isNaN(Number(segment))) // remove numbered segments
    return path.map(m => translate.instant(`title.${m}`)).join(' | ');
};

export const routes: Routes = [
    {
        path: 'help',
        loadComponent: () => import('./app-core/ui/sidenav/help/help'),
        title: titleResolver,
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'help/:item',
        loadComponent: () => import('./app-core/ui/sidenav/help/help'),
        title: titleResolver,
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'preferences',
        loadComponent: () => import('./app-core/ui/sidenav/account/account'),
        title: titleResolver,
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'home',
        loadComponent: () => import('./features/home/home'),
        title: titleResolver,
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'fas',
        loadComponent: () => import('./features/home/fas/fas'),
        title: titleResolver,
        canActivate: [OktaAuthGuard, permissionGuard],
        data: { expectedPermissions: [PermissionType.AccessFas] },
    },
    {
        path: 'fas-schedule',
        loadComponent: () => import('./features/home/fas-schedule/fas-schedule'),
        title: titleResolver,
        canActivate: [OktaAuthGuard, permissionGuard],
        data: { expectedPermissions: [PermissionType.AccessFas] },
    },
    {
        path: 'grns',
        loadComponent: () => import('./features/home/grns/grns'),
        title: titleResolver,
        canActivate: [OktaAuthGuard, permissionGuard],
        data: { expectedPermissions: [PermissionType.AccessGrns] },
    },
    {
        path: 'material-requests',
        loadComponent: () => import('./features/home/material-requests/material-requests'),
        title: titleResolver,
        canActivate: [OktaAuthGuard, permissionGuard],
        data: { expectedPermissions: [PermissionType.AccessMaterialRequests] },
    },
    {
        path: 'material-requests-item',
        loadComponent: () => import('./features/home/material-requests-item/material-requests-item'),
        title: titleResolver,
        canActivate: [OktaAuthGuard, permissionGuard],
        data: { expectedPermissions: [PermissionType.AccessMaterialRequests] },
    },
    {
        path: 'admin',
        loadComponent: () => import('./features/admin/admin'),
        title: titleResolver,
        canActivate: [OktaAuthGuard, permissionGuard],
        data: { expectedPermissions: [PermissionType.AccessRoles, PermissionType.AccessUsers, PermissionType.AccessAuditLogs] },
    },

    {
        path: 'sap-token',
        loadComponent: () => import('./features/sap-token/sap-token'),
        title: titleResolver,
        canActivate: [OktaAuthGuard, permissionGuard],
        data: { expectedPermissions: [PermissionType.AccessFas] },
    },
    {
        path: 'manual-pull-list',
        loadComponent: () => import('./features/home/manual-pull-list/manual-pull-list'),
        title: titleResolver,
        canActivate: [OktaAuthGuard, permissionGuard],
        data: { expectedPermissions: [PermissionType.AccessManualPullList] },
    },
    {
        path: 'print-label',
        loadComponent: () => import('./features/home/print-label/print-label'),
        title: titleResolver,
        canActivate: [OktaAuthGuard, permissionGuard],
        data: { expectedPermissions: [PermissionType.AccessPrintLabel] },
    },

    { path: 'login/callback', component: OktaCallbackComponent },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
];
